import type { LeadType, LeadTypeField } from '../types'

/**
 * Which lead detail fields appear in the workspace, by lead type.
 * Loan Officers only see the fields that matter for the loan scenario in front of them.
 */
export const leadTypeFields: Record<LeadType, LeadTypeField[]> = {
  Purchase: [
    { key: 'targetPrice', label: 'Target Purchase Price' },
    { key: 'downPayment', label: 'Down Payment' },
    { key: 'timeline', label: 'Buying Timeline' },
    { key: 'preApproval', label: 'Pre-Approval' },
    { key: 'creditBand', label: 'Credit Band' },
  ],
  Refinance: [
    { key: 'currentBalance', label: 'Current Balance' },
    { key: 'currentRate', label: 'Current Rate' },
    { key: 'estimatedValue', label: 'Estimated Home Value' },
    { key: 'goal', label: 'Stated Goal' },
    { key: 'creditBand', label: 'Credit Band' },
  ],
  'Cash-Out Refinance': [
    { key: 'currentBalance', label: 'Current Balance' },
    { key: 'estimatedValue', label: 'Estimated Home Value' },
    { key: 'cashOutTarget', label: 'Cash-Out Target' },
    { key: 'currentRate', label: 'Current Rate' },
    { key: 'creditBand', label: 'Credit Band' },
  ],
}
